import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_contentBlock = _resolveComponent("contentBlock")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_img = _resolveComponent("ion-img")!
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ScrollOrderHistory = _resolveComponent("ScrollOrderHistory")!

  return (!_ctx.isLoyaltyMember && !_ctx.hasOrderHistory)
    ? (_openBlock(), _createBlock(_component_ion_row, {
        key: 0,
        class: "ion-justify-content-start rewards-content-block"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_col, {
            size: "12",
            class: "ion-align-items-center ion-justify-content-center ion-text-center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_contentBlock, { slug: "home-page-nonmember-banner" })
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : (_openBlock(), _createBlock(_component_ion_row, {
        key: 1,
        class: "container ion-align-items-center ion-justify-content-start pr-8",
        style: {"margin-top":"-1px"}
      }, {
        default: _withCtx(() => [
          (_ctx.isLoyaltyMember && _ctx.hasOrderHistory)
            ? (_openBlock(), _createBlock(_component_ion_col, {
                key: 0,
                size: 4,
                class: "ion-align-items-center ion-text-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_img, {
                    alt: "Donatos Rewards Logo",
                    src: require('@/assets/donatos-rewards-logo-dark.svg'),
                    style: {"max-width":"250px","margin":"auto"}
                  }, null, 8, ["src"]),
                  _createVNode(_component_ion_text, { class: "account-info-text welcome-header" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Welcome" + _toDisplayString(_ctx.account.firstName ? `, ${_ctx.account.firstName}` : '') + "!", 1)
                    ]),
                    _: 1
                  }),
                  _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
                  (_ctx.isLoyaltyProcessing)
                    ? (_openBlock(), _createBlock(_component_ion_text, {
                        key: 0,
                        class: "account-info-text interstate-bold large",
                        style: {"display":"inline-flex"}
                      }, {
                        default: _withCtx(() => [
                          _cache[1] || (_cache[1] = _createTextVNode(" You have ")),
                          _createVNode(_component_ion_spinner, {
                            color: "primary",
                            name: "lines-small"
                          }),
                          _cache[2] || (_cache[2] = _createTextVNode(" points."))
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_ion_text, {
                        key: 1,
                        class: "account-info-text interstate-bold large"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("You have " + _toDisplayString(_ctx.pointsValue) + " points.", 1)
                        ]),
                        _: 1
                      })),
                  _createVNode(_component_ion_row, { class: "ion-justify-content-center rewards-content-block" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_contentBlock, { slug: "home-page-rewards-banner" })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : (_ctx.isLoyaltyMember && !_ctx.hasOrderHistory)
              ? (_openBlock(), _createBlock(_component_ion_col, {
                  key: 1,
                  size: 3,
                  class: "ion-align-items-center ion-text-center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_img, {
                      alt: "Donatos Rewards Logo",
                      src: require('@/assets/donatos-rewards-logo-dark.svg'),
                      style: {"max-width":"250px","margin":"auto"}
                    }, null, 8, ["src"])
                  ]),
                  _: 1
                }))
              : (!_ctx.isLoyaltyMember && _ctx.hasOrderHistory)
                ? (_openBlock(), _createBlock(_component_ion_col, {
                    key: 2,
                    size: 4,
                    class: "ion-align-items-center ion-text-center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_row, { class: "ion-justify-content-center rewards-content-block" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_contentBlock, { slug: "home-page-nonmember-banner" })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
          (_ctx.isLoggedIn && _ctx.hasOrderHistory)
            ? (_openBlock(), _createBlock(_component_ion_col, {
                key: 3,
                "size-sm": "6",
                class: _normalizeClass(["ion-align-items-center ion-text-left pl-16", `orders-${_ctx.orderHistoryCount}`])
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ScrollOrderHistory)
                ]),
                _: 1
              }, 8, ["class"]))
            : _createCommentVNode("", true),
          (_ctx.isLoggedIn && _ctx.isLoyaltyMember && !_ctx.hasOrderHistory)
            ? (_openBlock(), _createBlock(_component_ion_col, {
                key: 4,
                "size-sm": "6",
                class: "ion-align-items-center ion-text-center pl-16"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_text, { class: "account-info-text welcome-header" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Welcome" + _toDisplayString(_ctx.account.firstName ? `, ${_ctx.account.firstName}` : '') + "!", 1)
                    ]),
                    _: 1
                  }),
                  (_ctx.isLoyaltyProcessing)
                    ? (_openBlock(), _createBlock(_component_ion_text, {
                        key: 0,
                        class: "account-info-text interstate-bold large",
                        style: {"display":"inline-flex"}
                      }, {
                        default: _withCtx(() => [
                          _cache[4] || (_cache[4] = _createTextVNode(" You have ")),
                          _createVNode(_component_ion_spinner, {
                            color: "primary",
                            name: "lines-small"
                          }),
                          _cache[5] || (_cache[5] = _createTextVNode(" points."))
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_ion_text, {
                        key: 1,
                        class: "account-info-text interstate-bold large"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" You have " + _toDisplayString(_ctx.pointsValue) + " points.", 1)
                        ]),
                        _: 1
                      }))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.hasOrderHistory)
            ? (_openBlock(), _createBlock(_component_ion_col, {
                key: 5,
                size: "2",
                class: "ion-align-items-center ion-text-left pl-16 interstate-bold"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("a", {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.router.push({ path: '/history', name: 'history', params: { infoType: 'order' } }))),
                    color: "primary"
                  }, "ALL RECENT ORDERS")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.isLoggedIn && _ctx.isLoyaltyMember && !_ctx.hasOrderHistory)
            ? (_openBlock(), _createBlock(_component_ion_col, {
                key: 6,
                size: "3"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_row, { class: "ion-justify-content-center rewards-content-block" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_contentBlock, { slug: "home-page-rewards-banner" })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }))
}